import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { router } from './routes';
import { supabase } from '../utils/supabase/client';

/**
 * Global OAuth hash cleanup.
 * After Supabase processes the implicit-grant tokens from the URL hash,
 * strip them so they never linger in the address bar.
 */
function useCleanOAuthHash() {
  useEffect(() => {
    // Only act when the hash contains OAuth tokens
    if (!window.location.hash.includes('access_token')) return;

    // Wait for Supabase to finish consuming the hash during initialize()
    const cleanup = supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION') {
        // Supabase has consumed the tokens — safe to clear the hash now
        if (window.location.hash.includes('access_token')) {
          window.history.replaceState(
            null,
            '',
            window.location.pathname + window.location.search
          );
        }
      }
    });

    // Fallback: if onAuthStateChange never fires SIGNED_IN (e.g. session
    // already existed), clean up after a short delay as a safety net.
    const fallbackTimer = setTimeout(() => {
      if (window.location.hash.includes('access_token')) {
        window.history.replaceState(
          null,
          '',
          window.location.pathname + window.location.search
        );
      }
    }, 2000);

    return () => {
      cleanup.data.subscription.unsubscribe();
      clearTimeout(fallbackTimer);
    };
  }, []);
}

export default function App() {
  useCleanOAuthHash();
  return <RouterProvider router={router} />;
}